import { Controller } from '@hotwired/stimulus'
import { render, renderString } from 'nunjucks'
import GLightbox from 'glightbox'
import imageCompression from 'browser-image-compression'

import { router, Routes, currentMatch } from '../router'

import {
    checkOs,
    notifier,
    retrieveSession,
    retrieveState,
    retrieveTmp,
    updateState,
    sendEvent,
    setHtml,
    subscribeEvent,
    target,
    unsubscribeEvent,
    updateTmp,
    createToSendFromParams,
    addClass,
    removeClass
} from '../utils'

import { Events, Forms, Strings } from '../constants'

import {
    saveNotificationPostRequest
} from '../api'

export default class extends Controller {

    static targets = [
        'service-details',
        'form',
        'service_located',
        'content',
        'generate-order-container',
        'generate-order',
        'attend-order-container',
        'file',
        'evidences',
    ]

    static values = {
    }

    state = {
        session: null,
        id: null,
        notification: null,
        evidences: []
    }

    instances = {
        lightbox: {
            complaints: null,
            evidences: null
        },
        validator: null
    }

    serviceDetails = () => target(this, 'service-details')

    form = () => target(this, 'form')

    serviceLocated = () => target(this, 'service_located')

    content = () => target(this, 'content')

    generateOrderContainer = () => target(this, 'generate-order-container')

    generateOrder = () => target(this, 'generate-order')

    attendOrderContainer = () => target(this, 'attend-order-container')

    file = () => target(this, 'file')

    evidences = () => target(this, 'evidences')

    initialize = () => {

        const { data: { id } } = currentMatch()

        if (! id) {

            router.navigate(Routes[1].url, {
                historyAPIMethod: 'replaceState'
            })

            return
        }

        this.state.id = id

        this.instances.lightbox.evidences = GLightbox({
            touchNavigation: true,
            dragToleranceY: 0,
            elements: []
        })
    }

    connect = () => {

        this.refreshOnLogin()

        subscribeEvent(Events.ON_LOGIN, this.refreshOnLogin)
    }

    disconnect = () => {

        unsubscribeEvent(Events.ON_LOGIN, this.refreshOnLogin)
    }

    refreshOnLogin = () => {

        retrieveSession()
            .then((session) => {

                if (! session) {

                    sendEvent(Events.SHOW_LOGIN, { message: '' })

                    return
                }

                this.state.session = session

                return retrieveTmp()
                    .then((notification) => {

                        if (! notification || this.state.id !== notification.notificacion) {

                            router.navigate(Routes[1].url, {
                                historyAPIMethod: 'replaceState'
                            })

                            return
                        }

                        this.state.notification = notification

                        this.instances.lightbox.complaints = GLightbox({
                            touchNavigation: true,
                            dragToleranceY: 0,
                            elements: [{
                                href: `https://notificaciones.sys-dev.com.mx/proxy/?csurl=https://moviljal.cfe.mx/suterm/image.php/${btoa(notification.archivo)}`,
                                type: 'image',
                                title: `Notificación ${notification.notificacion}`,
                                description: renderString('Fecha {{ fecha | datetime }}', notification)
                            }]
                        })

                        setHtml(this.serviceDetails(), render('service-details.html', notification))

                        this.instances.validator = new Validator(this.form(), this.save, Forms)
                    })
                    .catch(() => {})
            })
            .catch(() => {

                sendEvent(Events.SHOW_LOGIN, { message: '' })
            })
    }

    save = (errors, isValid) => {

        if (! isValid) {

            return
        }

        if (! this.state.evidences.length > 0) {

            notifier.alert(Strings.ERROR_NOT_EVIDENCES)

            return
        }

        sendEvent(Events.SHOW_LOADING)

        const params = new FormData(this.form())

        params.append('rpe', this.state.session.rpe)
        params.append('longitud', '0.0')
        params.append('latitud', '0.0')
        params.append('notificacion', this.state.notification.notificacion)
        params.append('orden', this.state.notification.orden)
        params.append('fecha', this.state.notification.fecha)
        params.append('zona', this.state.notification.zona)
        params.append('rpu', this.state.notification.rpu)
        params.append('medidores', this.state.notification.medidores)
        params.append('version', Strings.VERSION)
        params.append('os', checkOs())

        if (! params.has('servicio_localizado')) {

            params.append('servicio_localizado', 0)

        } else {

            params.set('servicio_localizado', 1)
        }

        if (! params.has('cortado')) {

            params.append('cortado', 0)

            if (! params.has('generar_orden')) {

                params.append('generar_orden', 0)

                params.append('atender_orden', 0)

            } else {

                params.set('generar_orden', 1)

                if (! params.has('atender_orden')) {

                    params.append('atender_orden', 0)

                } else {

                    params.set('atender_orden', 1)
                }
            }

        } else {

            params.set('cortado', 1)

            params.append('generar_orden', 0)

            params.append('atender_orden', 0)
        }

        const { geolocation } = navigator

        if (! geolocation) {

            notifier.info(Strings.ERROR_LOCATION_FEATURE)

            sendEvent(Events.HIDE_LOADING)

            return
        }

        geolocation.getCurrentPosition(({ coords: { latitude, longitude } }) => {

            params.set('longitud', longitude.toString())
            params.set('latitud', latitude.toString())

            this.state.evidences.forEach((evidence, number) => {

                params.append(`archivo${number}`, evidence.file)
            })

            sendEvent(Events.HIDE_LOADING)

            saveNotificationPostRequest(params)
                .then((response) => this.onSave(response, params))
                .catch((response) => this.onSave(response, params))

        }, (error) => {

            this.errorLocation(error.code !== 1)

        }, {
            enableHighAccuracy: true,
            timeout: 30000,
            maximumAge: 60000
        })
    }

    onSave = (response, params) => {

        if (! response.estado) {

            this.onSaveFail(params)

            return
        }

        if (response.estado) {

            notifier.success(response.mensaje)

            updateTmp({ update: true })
                .then(() => {

                    router.navigate(Routes[1].url, {
                        historyAPIMethod: 'replaceState'
                    })
                })
                .catch(() => {

                    router.navigate(Routes[1].url, {
                        historyAPIMethod: 'replaceState'
                    })
                })
        }
    }

    onSaveFail = (params) => {

        sendEvent(Events.SHOW_LOADING)

        createToSendFromParams(this.state.notification, params)
            .then((toSend) => {

                return retrieveState()
                    .then((state) => {

                        if (! state || ! state.toSend) {

                            state = state || {}

                            state.toSend = []
                        }

                        return updateState({
                            toSend: [ toSend, ...state.toSend ]
                        })
                    })
            })
            .then(() => {

                sendEvent(Events.HIDE_LOADING)

                notifier.info(Strings.MESSAGE_VISIT_NOT_REGISTERED)

                router.navigate(Routes[5].url, {
                    historyAPIMethod: 'replaceState'
                })
            })
            .catch(() => {

                notifier.alert(Strings.ERROR_SAVING_VISIT)

                sendEvent(Events.HIDE_LOADING)
            })
    }

    openMaps = ({ params }) => {

        if (isNaN(params.x) || isNaN(params.y) || params.domicilio === '') {

            return
        }

        const platform = (navigator.userAgentData || navigator).platform || 'unknown'

        const x = parseFloat(params.x)
        const y = parseFloat(params.y)

        if (x !== 0 && y !== 0) {

            if (platform.indexOf('iPhone') !== -1 ||
                    platform.indexOf('iPod') !== -1 ||
                        platform.indexOf('iPad') !== -1) {

                window.open(`maps://maps.google.com/maps?daddr=${params.x},${params.y}`)

            } else {

                window.open(`https://maps.google.com/maps?daddr=${params.x},${params.y}`)
            }

        } else {

            if (platform.indexOf('iPhone') !== -1 ||
                platform.indexOf('iPod') !== -1 ||
                platform.indexOf('iPad') !== -1) {

                window.open(`maps://maps.google.com/maps?daddr=${params.domicilio}`)

            } else {

                window.open(`https://maps.google.com/maps?daddr=${params.domicilio}`)
            }
        }
    }

    showComplaints = () => {

        this.instances.lightbox.complaints.open()
    }

    showEvidences = () => {

        this.instances.lightbox.evidences.open()
    }

    onToggleLocated = ({ target : { checked } }) => {

        if (checked) {

            removeClass(this.content(), 'is-hidden')

            return
        }

        addClass(this.content(), 'is-hidden')
    }

    onToggleStatus = ({ target : { checked } }) => {

        if (this.generateOrder().checked) {

            removeClass(this.attendOrderContainer(), 'is-hidden')

        } else {

            addClass(this.attendOrderContainer(), 'is-hidden')
        }

        if (checked) {

            addClass(this.generateOrderContainer(), 'is-hidden')

            return
        }

        removeClass(this.generateOrderContainer(), 'is-hidden')
    }

    onToggleGenerateOrder = ({ target : { checked } }) => {

        if (checked) {

            removeClass(this.attendOrderContainer(), 'is-hidden')

            return
        }

        addClass(this.attendOrderContainer(), 'is-hidden')
    }

    takePicture = (event) => {

        sendEvent(Events.SHOW_CAMERA, this.onTakePicture)

        event.stopPropagation()
    }

    onTakePicture = (result) => {

        result.then((picture) => {

            this.state.evidences.push(picture)

            this.updateEvidencesLightbox()

            setHtml(this.evidences(), render('evidences.html', this.state))

        }).catch(() => {})
    }

    chooseFile = (event) => {

        this.file().click()

        event.stopPropagation()
    }

    onChooseFile = ({ target: { files } }) => {

        if (files.length === 0) {

            return
        }

        sendEvent(Events.SHOW_LOADING)

        const promises = [];

        for (let file in files) {

            file = files[file]

            promises.push(
                imageCompression(file, {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1280,
                    useWebWorker: true
                })
                    .then((compressedFile) => {

                        file = compressedFile

                        return imageCompression.getDataUrlFromFile(compressedFile)
                    })
                    .then((uri) => {

                        this.state.evidences.push({
                            uri: uri,
                            file: file
                        })

                        this.updateEvidencesLightbox()

                        setHtml(this.evidences(), render('evidences.html', this.state))
                    })
                    .catch((error) => {

                        const message = error.toString()

                        if (message.endsWith('is not an image')) {

                            notifier.alert(Strings.ERROR_NOT_IMAGE)
                        }
                    })
            )
        }

        Promise.all(promises).finally(() => {

            sendEvent(Events.HIDE_LOADING)
        })
    }

    removeEvidence = (event) => {

        this.state.evidences.splice(event.params.index,1)

        this.updateEvidencesLightbox()

        setHtml(this.evidences(), render('evidences.html', this.state))

        event.stopPropagation()
    }

    updateEvidencesLightbox = () => {

        const elements = this.state.evidences.map((evidence) => ({
            href: evidence.uri,
            type: 'image'
        }))

        this.instances.lightbox.evidences.setElements(elements)
    }

    errorLocation = (hasPermissions) => {

        notifier.alert(hasPermissions ? Strings.ERROR_LOCATION : Strings.ERROR_LOCATION_PERMISSION)

        sendEvent(Events.HIDE_LOADING)
    }
}
